import * as React from 'react';
import logo from './logo.png';

export default () => <img src={logo} alt="Piral Cloud Logo" title="Piral Cloud" />;
